import React from "react";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export const useOperativeStateConfig = create(
    persist(
        (set, get) => ({
            autoPlaySlider: false,
            changeAutoPlaySliderValue: () =>
                set({ autoPlaySlider: !get().autoPlaySlider }),
        }),
        {
            name: "auto-play-slider-storage",
            storage: createJSONStorage(() => sessionStorage),
        }
    )
);

export const withOperativeStateStore = (BaseComponent) => (props) => {
    const store = useOperativeStateConfig();

    return <BaseComponent {...props} store={store} />;
};
